<soft-page [blockScrollY]="blockScrollY()">
  @if ((breakpointService.isMobile() && selected()) || header()?.template()) {
  <soft-page-header #pageHeader>
    @if(breakpointService.isMobile() && !!selected()) {
    <ng-container
      *ngTemplateOutlet="masterTemplate() ?? null; context: {data: masterDetail?.selected()}"
    ></ng-container>
    } @else {
    <ng-container *ngTemplateOutlet="header()?.template() ?? null"></ng-container>
    }
  </soft-page-header>
  } @let isLoaded = resource().status() === 'resolved' || resource().status()
  === 'local'; @if (!isLoaded) {
  <div class="flex items-center justify-center h-full">
    <soft-loading-spinner></soft-loading-spinner>
    <p class="italic text-light pl-2">Die Daten werden geladen...</p>
  </div>
  }
  <soft-master-detail
    class="block full-width"
    [class]="isLoaded ? '' : 'hidden'"
    [data]="resource().value() ?? []"
    [selectable]="isLoaded"
    [masterTemplate]="isLoaded ? masterTemplate() : commonMasterLoadingTemplate"
    [masterHeaderTemplate]="masterHeaderTemplate()"
    [masterBottomTemplate]="masterBottomTemplate()"
    [masterContainerClass]="masterContainerClass()"
    [masterTemplateConfig]="masterTemplateConfig()"
    [detailTemplate]="pageDetailTemplate"
    [detailBottomTemplate]="detailBottomTemplate()"
    [detailPlaceholder]="detailPlaceholder()"
    [detailHeaderVisible]="false"
    (selectedChange)="selectedChange.emit($event)"
    #masterDetail
  >
    <ng-content></ng-content>
  </soft-master-detail>
</soft-page>

<ng-template #pageDetailTemplate>
  <ng-container
    *ngTemplateOutlet="detailTemplate(); context: { data: selected() }"
  ></ng-container>
  <soft-menu-outlet
    class="bottom-menu sticky bottom-0 shrink-0 shell-content-bg"
    [name]="'detail-bottom'"
  ></soft-menu-outlet>
</ng-template>

<ng-template #commonMasterLoadingTemplate>
  <soft-resource-container [resource]="resource()" [loadingTemplate]="loadingTemplate">
  </soft-resource-container>
</ng-template>
<ng-template #loadingTemplate>
  <div *softRepeat="loadingEntries()">
    <ng-container
      *ngTemplateOutlet="masterLoadingTemplate() ?? defaultLoadingTemplate"
    ></ng-container>
  </div>
</ng-template>

<ng-template #defaultLoadingTemplate>
  <div
    class="flex flex-row justify-between pointer hover:bg-hover items-center gap-2 px-2"
  >
    <div class="flex flex-row items-center gap-2">
      <soft-icon [name]="'fa-regular fa-spinner-third'"></soft-icon>
      <div class="flex flex-col">
        <div class="w-1/2 bg-background rounded"></div>
        <div class="w-1/3 bg-background rounded"></div>
      </div>
    </div>
    <soft-icon [name]="'fa-regular fa-chevron-right'"></soft-icon>
  </div>
</ng-template>
